module.exports = __webpack_public_path__ + "dd6fbbc9e1a241a761162b2b51dc9e14.svg";